import { Fragment, useEffect, useState } from "react";
import "./index.scss";
import DynamicForm from "components/DynamicForm";
import Modal from "react-bootstrap/Modal";
import FormButton from "components/FormButton";
import { validate } from "components/DynamicForm/validate";
import { useDispatch,useSelector } from "react-redux";
import Recursive from "components/Recursive";
import { 
  setRecursiveFormData,
  setIsSignerRecursion,
  setShowRecursiveForm,
  setIsEditRecursiveForm,
  clearRecursiveFormData,
  setShowAddMore,
  cleardeleteRecursiveDocument,
} from "redux/recursiveReducer";
import { QuizModule } from "lib";

const PopupComp = (props) => {
  const {
    selectedData,
    setSelectedData,
    form_elements,
    form_buttons,
    // clearFieldError,
    modalShow,
    setModalShow,
    handleNext,
    modalSize = "md",
    handleLinkWithCrn,
    handleDelinkWithCrn,
    handleTerminate,
    handelAddRecursiveData,
    handleCREdit,
    form_Err
  } = props;

  const [formErr, setFormErr] = useState({});
  const dispatch = useDispatch();
  const recursive = useSelector((state) => state?.recursive);
  const staticData = useSelector((state) => state?.staticData);
  const popupReducer = useSelector((state) => state?.popupReducer)
  const selectedQuestion = useSelector(
    (state) => state.formData?.selectedQuestion
  );
  const config = useSelector(( state) => state?.configurationReducer?.config?.wf_journey);
 
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const role_id = useSelector((state)=> state?.popupReducer?.role_id[0])
  const assign_approval_to = useSelector((state)=>state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow?.source_data?.assign_approval_user_id);
  const assigned_dynamic_step = useSelector((state)=>state?.dashboardDetailReducer?.dashboardDetailData?.primaryworkflow?.source_data?.assigned_dynamic_step)

  useEffect(()=>{
    if(Object.entries(form_Err)?.length){
      setFormErr(form_Err)
    }
  },[form_Err])

  const handleBack = () => {
    setModalShow(false);
    setFormErr({})
  };
  const clearFieldError = (fields, isList) => {
    fields = isList ? fields : [fields];
    let err =formErr;

    for (let key in fields) {
      const _field = fields[key];
      if (err[_field] !== undefined) {
        delete err[_field];
      }
    }
    setFormErr(err);
  };

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  const handleValidate = async(args,callback) => {
    let errors;
    const questionsValidation = Object.assign({}, ...form_elements.filter((item) => item.type === 'quizModule'))
    let validateFields = [];
    let fieldType = "";

    fieldType = questionsValidation.type;
    questionsValidation?.input_fields?.map((_item) => {
      if (
        !_item.hasOwnProperty("show") ||
        (_item.hasOwnProperty("show") &&
        IndirectEval(_item.show))
      ) {
        validateFields = [...validateFields, _item];
      }
    });
    
    if(form_elements[0]?.type ==  "recursive"){
      let form_element = form_elements[0]?.input_fields
      const formElementsValidated = form_element.filter((item)=> item.show ? eval(item.show) : true)
      errors = await validate(formElementsValidated, recursive?.recursiveFormData, dispatch,staticData,null,recursive,selectedData,role_id,assign_approval_to,assigned_dynamic_step);
    }else{
      const formElementsValidated = form_elements.filter((item)=> item.show ? eval(item.show) : true)
      errors = await validate(formElementsValidated, selectedData, dispatch,staticData,null,null,null,config,role_id,assign_approval_to,assigned_dynamic_step);
    }

    if(fieldType) {
      let err =  await validate(validateFields, selectedQuestion, dispatch, workflowUser,role_id,assign_approval_to,assigned_dynamic_step);
      if(Object.keys(err)?.length){
        errors = {...errors,...err}
      }
    }
    if (Object.keys(errors)?.length) {
      setFormErr(errors);
    } else {
      setFormErr({});
      callback(args);
    }
  };

  return (
    <>
      {modalShow ? (
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          form_elements={form_elements}
          form_buttons={form_buttons}
          handleNext={(arg)=>handleValidate(arg,handleNext)}
          handleBack={handleBack}
          formErr={formErr}
          setFormErr={setFormErr}
          clearFieldError={clearFieldError}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          modalSize={modalSize}
          handleLinkWithCrn={handleLinkWithCrn}
          handleDelinkWithCrn={handleDelinkWithCrn}
          handleTerminate={handleTerminate}
          handelAddRecursiveData={handelAddRecursiveData}
          handleCREdit={(arg)=>handleValidate(arg,handleCREdit)}
        />
      ) : (
        <></>
      )}
    </>
  );
};

function MyVerticallyCenteredModal(props) {
  const {
    show,
    handleNext,
    handleBack,
    form_elements,
    form_buttons,
    selectedData,
    setSelectedData,
    formErr,
    setFormErr,
    clearFieldError,
    modalSize,
    handleLinkWithCrn,
    handleDelinkWithCrn,
    handleTerminate,
    handelAddRecursiveData,
    handleCREdit
  } = props;
  const dispatch = useDispatch()
  const recursiveFormData = useSelector(
    (state) => state.recursive?.recursiveFormData
  )
  const recursive = useSelector(
    (state) => state.recursive
  )
  const [approvalType, setApprovalType] = useState(false)
  const dataPreview = useSelector((state) => state.recursive?.showDataPreview);
  const handleSkip =()=>{

  }
  const selectedQuestion = useSelector(
    (state) => state.formData?.selectedQuestion
  );
  const handleCancel =() =>{
    dispatch(setShowAddMore(true));
    recursive?.showRecursiveForm && dispatch(setShowRecursiveForm(false));
    !recursive?.showRecursiveForm && dispatch(clearRecursiveFormData());
    dispatch(setIsEditRecursiveForm(false));
    dispatch(cleardeleteRecursiveDocument())
    setFormErr({});
  }

    useEffect(() => {
      if(form_elements) {
          form_elements.forEach((item, index) => {
            if(item.type === 'quizModule'){
              setApprovalType(true)
            }
          }) 
      }
    }, [form_elements])

  return (
      <>
          <Modal
              className="containermodal mt-1"
              show={show}
              onHide={handleBack}
              size={approvalType ? 'lg' : modalSize}
              centered
              scrollable
              dialogClassName="modal-theme-scrollbar"
          >
              {/* <div className="close-btn-container">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleBack}
          ></button>
        </div> */}
              {/* <Modal.Header className="pb-0 pt-2 px-1" closeButton>
        </Modal.Header> */}

              <Modal.Body className="position-relative m-3 p-0 overflow-x-hidden">
                  <button className="btn btn-close position-absolute end-0 top-0" onClick={handleBack}>
                
                  </button>
                  <div className="row">
                      {form_elements.map((item, index) => {
                          if (item.type === 'recursive') {
                              if (item.signer_recursion) {
                                  dispatch(
                                      setIsSignerRecursion(
                                          item.signer_recursion
                                      )
                                  );
                              }
                              return (
                                  <Fragment key={index}>
                                      <Recursive
                                          recursiveTrigger={
                                              item.recursive_trigger
                                          }
                                          customStyles={
                                            item.custom_styles

                                          }
                                          recursiveName={item.name}
                                          inputFields={item.input_fields}
                                          handleNext={handleNext}
                                          handleSkip={handleSkip}
                                          handleCancel={handleCancel}
                                          selectedData={recursiveFormData}
                                          setSelectedData={setRecursiveFormData}
                                          recursiveActions={
                                              item.recursive_actions
                                          }
                                          dataPreview={dataPreview}
                                          clearFieldError={clearFieldError}
                                          formErr={formErr}
                                          recursiveRead={item.read}
                                          setFormErr={setFormErr}
                                          recursiveTitle={item.title}
                                          minLength={item.min_length}
                                          maxLength={item.max_length}
                                          SignerRecursion={
                                              item.signer_recursion
                                          }
                                          triggerEsignRequest={
                                              item.trigger_esign_request
                                          }
                                          signaturePosition={
                                              item.signature_position
                                          }
                                          signer_validation_name={
                                              item.signer_validation_name
                                          }
                                      />
                                  </Fragment>
                              );
                          } 
                          if(item.type === 'quizModule') {
                            return (
                              <Fragment>
                                <QuizModule 
                                  inputFields={item.input_fields}
                                  clearFieldError={clearFieldError}
                                  formErr={formErr}
                                  selectedData={selectedQuestion}
                                  setSelectedData={setSelectedData}
                                  questionnaireId={item.id}
                                  evaluationRules={item.rules}
                                  type={approvalType}
                                  handleNext={handleNext}
                                />
                              </Fragment>
                            )
                          }
                          else {
                              return (
                                  <Fragment key={index}>
                                      <DynamicForm
                                          formFields={item}
                                          primaryUser={selectedData}
                                          selectedData={selectedData}
                                          setSelectedData={setSelectedData}
                                          formErr={formErr}
                                          clearFieldError={clearFieldError}
                                      />
                                  </Fragment>
                              );
                          }
                      })}
                      <FormButton
                          selectedData={selectedData}
                          formButtons={form_buttons}
                          handleNext={handleNext}
                          handleBack={handleBack}
                          handleLinkWithCrn={handleLinkWithCrn}
                          handleDelinkWithCrn={handleDelinkWithCrn}
                          handleTerminate={handleTerminate}
                          handelAddRecursiveData={handelAddRecursiveData}
                          handleCREdit={handleCREdit}
                      />
                  </div>
              </Modal.Body>
          </Modal>
      </>
  );
}

export function GenericModal(props) {
  const { show, onClose, modalSize, children } = props;
  return (
    <Modal
      className=""
      show={show}
      onHide={onClose}
      size={modalSize}
      centered
      scrollable
      dialogClassName="modal-theme-scrollbar"
    >
      {children}
    </Modal>
  );
}

export default PopupComp;
